import { render } from "./DoctorBio.vue?vue&type=template&id=232a1099&scoped=true"
import script from "./DoctorBio.vue?vue&type=script&lang=js"
export * from "./DoctorBio.vue?vue&type=script&lang=js"

import "./DoctorBio.vue?vue&type=style&index=0&id=232a1099&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232a1099"]])

export default __exports__